module.exports = __webpack_public_path__ + "static/media/truba-kv-model.d21578cb.png";